import { useEffect, useState } from 'react'
import { ref, listAll, getDownloadURL } from 'firebase/storage'
import { storage, auth } from '../../../../firebase'
import { onAuthStateChanged } from 'firebase/auth'
import { DownloadSimple, FileText, Spinner } from '@phosphor-icons/react'
import { Subtext } from '../../../../Components/Screen/Text/Body'

export function useDemonstrativos(nftId, refreshKey = 0) {
  const [items, setItems] = useState(null) // null = loading
  const [error, setError] = useState('')

  useEffect(() => {
    if (!nftId) {
      setItems([])
      return
    }
    let cancelled = false
    setItems(null)
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) return
      try {
        const list = await listAll(ref(storage, `demonstrativos/${nftId}`))
        const resolved = await Promise.all(
          list.items.map(async (item) => ({
            name: item.name,
            fullPath: item.fullPath,
            url: await getDownloadURL(item),
          }))
        )
        if (!cancelled) setItems(resolved)
      } catch (err) {
        if (!cancelled) {
          setItems([])
          setError(err.message || 'Erro ao listar arquivos')
        }
      }
      unsubscribe()
    })
    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [nftId, refreshKey])

  return { items, error }
}

export function DemonstrativosList({ nftId, refreshKey }) {
  const { items } = useDemonstrativos(nftId, refreshKey)

  if (items === null) {
    return (
      <div className="flex items-center gap-2 text-cinza">
        <Spinner size={16} className="animate-spin" />
        <Subtext className="text-cinza">Carregando demonstrativos...</Subtext>
      </div>
    )
  }

  if (items.length === 0) return null

  return (
    <div className="flex flex-col gap-2 w-full max-w-md">
      <Subtext className="text-cinza">Demonstrativos disponíveis</Subtext>
      <ul className="flex flex-col gap-1">
        {items.map((item) => (
          <li
            key={item.fullPath}
            className="flex items-center justify-between gap-2 px-3 py-2 border border-cinzaescuro rounded-lg"
          >
            <span className="flex items-center gap-2 min-w-0">
              <FileText size={18} className="text-verdeClaro shrink-0" />
              <Subtext className="truncate text-branco">{item.name}</Subtext>
            </span>
            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              download={item.name}
              className="text-verdeClaro hover:opacity-80 transition shrink-0"
              title="Baixar"
            >
              <DownloadSimple size={18} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
